var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGpay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 40,
    viewBox: "0 0 62 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 40,
    rx: 2,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5258 24.5154V19.82H31.8957C32.8669 19.82 33.6865 19.4872 34.3548 18.831L34.5151 18.6646C35.7357 17.3059 35.6556 15.1892 34.3548 13.9321C33.7044 13.2666 32.8134 12.9062 31.8957 12.9246H28.0913V24.5154H29.5258ZM29.526 18.3964V14.348H31.9319C32.4488 14.348 32.9389 14.5513 33.3042 14.921C34.0795 15.6975 34.0973 16.9915 33.3488 17.7956C32.9834 18.1931 32.4666 18.4149 31.9319 18.3964H29.526Z",
    fill: "#3C4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2062 17.2041C40.5915 16.6218 39.754 16.326 38.6937 16.326C37.3306 16.326 36.306 16.8436 35.6289 17.8696L36.894 18.6922C37.3573 17.9898 37.9899 17.6385 38.7918 17.6385C39.2996 17.6385 39.7896 17.8326 40.1727 18.1839C40.5469 18.5166 40.7608 18.9973 40.7608 19.5056V19.8476C40.2084 19.5334 39.5134 19.367 38.6581 19.367C37.6602 19.367 36.8584 19.6073 36.2614 20.0972C35.6645 20.5871 35.3616 21.2341 35.3616 22.0567C35.3438 22.8054 35.6556 23.5171 36.208 23.9978C36.7693 24.5154 37.482 24.7742 38.3195 24.7742C39.3085 24.7742 40.0925 24.3213 40.6895 23.4154H40.7519V24.5154H42.1239V19.6258C42.1239 18.5998 41.821 17.7864 41.2062 17.2041ZM37.313 23.055C37.019 22.8332 36.8407 22.4727 36.8407 22.0845C36.8407 21.6501 37.0368 21.2896 37.4199 21.003C37.812 20.7165 38.3021 20.5686 38.8813 20.5686C39.6833 20.5594 40.3071 20.7442 40.7527 21.114C40.7527 21.7425 40.5121 22.2878 40.0398 22.75C39.612 23.1936 39.0328 23.4432 38.4269 23.4432C38.0259 23.4525 37.6338 23.3138 37.313 23.055Z",
    fill: "#3C4043"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2067 28L50 16.5848H48.4408L46.2224 22.2785H46.1956L43.9237 16.5848H42.3645L45.5096 24.007L43.7277 28H45.2067Z",
    fill: "#3C4043"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5736 18.8033C24.5736 18.3504 24.5379 17.8974 24.4667 17.4538H18.4171V20.0141H21.8829C21.7403 20.8367 21.277 21.5762 20.5999 22.0383V23.7021H22.6669C23.8786 22.5467 24.5736 20.8367 24.5736 18.8033Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4173 25.3104C20.1458 25.3104 21.6067 24.7188 22.6669 23.7021L20.5999 22.0383C20.0208 22.445 19.2815 22.6762 18.4173 22.6762C16.7423 22.6762 15.3257 21.5023 14.8178 19.931H12.6885V21.6502C13.7754 23.8963 15.9939 25.3104 18.4173 25.3104Z",
    fill: "#34A853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8178 19.931C14.5505 19.1084 14.5508 18.2117 14.8181 17.3799V15.6699H12.6884C11.7705 17.5462 11.7705 19.7646 12.6884 21.6409L14.8178 19.931Z",
    fill: "#FBBC04"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4173 14.6347C19.335 14.6162 20.217 14.9767 20.8763 15.6329L22.7117 13.7289C21.5446 12.6012 20.0121 11.9819 18.4173 12.0004C15.9939 12.0004 13.7753 13.4238 12.6884 15.6699L14.8178 17.3891C15.3257 15.8085 16.7423 14.6347 18.4173 14.6347Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpay);
export default __webpack_public_path__ + "static/media/gpay.a5408da867709c22535b4ed04a3e9320.svg";
export { ForwardRef as ReactComponent };